/* jshint camelcase: false */
// jscs:disable requireCamelCaseOrUpperCaseIdentifiers
'use strict';

var $ = require('jquery');
var utilities = require('../utilities');

$.validator.addMethod('email', function(value) {
  return utilities.isEmailAddress(value);
});



// WEBPACK FOOTER //
// ./assets/js/validators/email.js